import { render, staticRenderFns } from "./categoryScoreDialog.vue?vue&type=template&id=6c8f8c77&"
import script from "./categoryScoreDialog.vue?vue&type=script&lang=js&"
export * from "./categoryScoreDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports